module.exports = __webpack_public_path__ + "img/3.ef85ab97.svg";